import {doc} from './docs.js';
import {START} from 'messaging/message-types.js';

doc(
    "bangbang",
    {
    },
    "Sends bang message to outlets in order (left-to-right). Each argument creates an outlet eg: bangbang 0 0 0 0 ceates 4 outlets)",
    (x) => x,
    {
        inlets: 1,
        tags: "Bang"
    });

const bangbang = (object, ...args) => {
    return (msg) => {
        // wheneve a message is received send
        // "bang" from each outlet in order
        args.forEach(
            (arg, i) => {
                if (arg() === undefined) {
                    return;
                }
                object.sendMessage(
                    object.outputByNumber(i), "bang");
            });
    };
};

doc(
    "messagemessage",
    {
    },
    "Sends messages to outlets in order (left-to-right). Each argument creates an outlet eg: bangbang 0 0 0 0 ceates 4 outlets)",
    (x) => x,
    {
        inlets: 1,
        tags: "Bang"
    });

const messagemessage = (object, ...args) => {
    return (msg) => {
        // wheneve a message is received send
        // "bang" from each outlet in order
        let list = [];
        args.forEach(
            (arg, i) => {
                if (arg() === undefined) {
                    list.push(undefined);
                }
                list.push(msg[0]);
            });
        return list;
    };

};


doc(
    "altbang",
    {
    },
    "Sends bang message to outlet alternating order (left-to-right)",
    (x) => x,
    {
        inlets: 1,
        tags: "Bang"
    });

const altbang = (object, ...args) => {
    let counter = 0;
    object.needsStart = true;
    return ([msg]) => {
        if (msg === START) {
            counter = 0;
            return;
        }
        // wheneve a message is received send
        // "bang" from each outlet in order
        let _args = args.filter(arg => arg() !== undefined);
        let i = (counter++)%_args.length;
        object.sendMessage(
            object.outputByNumber(i), "bang");
    };
};

doc(
    "alt",
    {
    },
    "Sends message to outlet alternating order (left-to-right)",
    (x) => x,
    {
        inlets: 1,
        tags: "Order"
    });

const alt = (object, ...args) => {
    let counter = 0;
    object.needsStart = true;
    return ([msg]) => {
        if (msg === START) {
            counter = 0;
            return;
        }
        // wheneve a message is received send
        // "bang" from each outlet in order
        let _args = args.filter(arg => arg() !== undefined);
        let i = (counter++)%_args.length;
        object.sendMessage(
            object.outputByNumber(i), msg);
    };
};

doc(
    "ifSend",
    {
    },
    "Sends message if argument is true",
    (x) => 1,
    {
        inlets: 2,
    });

const ifSend = (object, condition) => {
    return (msg) => {
        if (condition()) {
            return msg;
        }
        return undefined;
    };
};


doc(
    "randomThru",
    {
    },
    "Sends message to a randomly selected outlet",
    (x) => x,
    {
        inlets: 1,
        tags: "Order"
    });

const randomThru = (object, ...args) => {
    let counter = 0;
    object.needsStart = true;
    return ([msg]) => {
        if (msg === START) {
            counter = 0;
            return;
        }
        // wheneve a message is received send
        // "bang" from each outlet in order
        let _args = args.filter(arg => arg() !== undefined);
        let len = _args.length;
        let index = Math.floor(Math.random() * len);
        object.sendMessage(
            object.outputByNumber(index), msg);
    };
};



export const order = {
    randomThru,
    ifSend,
    messagemessage,
    alt,
    bangbang,
    altbang
};
